import { CartSelection } from '../hooks/cart';

/**
 * Shuffle.
 */
export const shuffle = (arr: any[]): any[] => {
	const tmp: any[] = [];
	let m = arr.length; let t; let
		i;
	while (m) {
		m -= 1;
		i = Math.floor(Math.random() * (m));
		t = tmp[m];
		tmp[m] = arr[i];
		tmp[i] = t;
	}
	return tmp;
};

/**
 * Get a random color.
 * Use within useMemo to avoid re-rendering a new color value.
 */
export const randomColorVar = () => {
	const colors = [
		'--ea-red-orange',
		'--ea-teal',
		'--ea-blue',
		'--ea-purple',
	];
	return colors[Math.floor(Math.random() * colors.length)];
};

/**
 * Generate a random color list.
 */
export const randomColorList = () => {
	const colors = [
		'--ea-red-orange',
		'--ea-teal',
		'--ea-blue',
		'--ea-purple',
	];
	const t = Math.floor(Math.random() * 2);
	if (t === 0) {
		return colors.reverse();
	}
	return colors;
};

/**
 * Determine if a button is selected.
 */
export function isSelected(
	selections: Map<number, CartSelection>,
	amount: number,
	id: number,
): boolean {
	if (selections.has(id) && selections.get(id).manualInput === false) {
		return selections.get(id).amount === amount;
	}
	return false;
}

/**
 * isEqual
 */
export function deepEqual(x: any, y: any): boolean {
	const ok = Object.keys;
	const tx = typeof x;
	const ty = typeof y;
	return x && y && tx === 'object' && tx === ty ? (
		ok(x).length === ok(y).length
		&& ok(x).every((key) => deepEqual(x[key], y[key]))
	) : (x === y);
}

/**
 * Scroll top.
 */
export function scrollToSelector(selector: string, offset: number = 0, delay: number = 0): void {
	if (!selector) {
		return;
	}
	setTimeout(() => {
		const s = document.querySelector(selector);
		if (!s) return;
		// Position relative to document.
		const t = s.getBoundingClientRect().top + document.documentElement.scrollTop;
		window.scrollTo({
			top: t + offset,
			behavior: 'smooth',
		});
	}, delay);
}

/**
 * Is mobile view.
 */
export function isMobile(): boolean {
	return window.innerWidth <= 768;
}
